import { Card, Checkbox, Divider, Flex, Skeleton, Text } from "components/common"
import { t } from "i18next"
import theme from "utils/themeVars"
import { formatFractionalSaleAmount } from "../utilis/fractionalSaleCalculations"
import styles from "./fractionalBlocksSummary.module.less"
import { FRACTIONAL_PAYMENT_CHANNEL_PSID, FRACTIONAL_PAYMENT_CHANNEL_STANDARD, resolvePsidPaymentModeKey } from "../fractionalPaymentUtils"
import { useMemo } from "react"
import { Form } from "antd"

export default function FractionalBlocksSummary({
  blockCount,
  blocksTotal,
  taxTotal,
  partnerFeeTotal,
  grandTotal,
  feeLoading,
  isFiler,
  modeOfPayments,
  processingFee,
  form,
}) {
  const summarySkeleton = <Skeleton active height={20} width={72} />

  const rows = [
    {
      label: `${t("Property blocks")} (x${+blockCount > 0 ? blockCount : 1})`,
      value: formatFractionalSaleAmount(blocksTotal),
    },
    {
      label: t("Advance tax ({{filerStatus}})", {
        filerStatus: isFiler ? t("Filer") : t("Non Filer"),
      }),
      value: feeLoading ? summarySkeleton : formatFractionalSaleAmount(taxTotal),
    },
    {
      label: t("Processing fees"),
      value: formatFractionalSaleAmount(processingFee),
    },
    {
      label: t("Partner fee"),
      value: feeLoading ? summarySkeleton : formatFractionalSaleAmount(partnerFeeTotal),
    },
  ]

  const psidPaymentModeKey = useMemo(() => resolvePsidPaymentModeKey(modeOfPayments), [modeOfPayments])

  const cardLabel = (
    <Flex justify="space-between" align="center">
      <Text type="secondary">{t("Sale summary")}</Text>
      {!!psidPaymentModeKey && (
        <Form.Item name="fractionalPaymentChannel" style={{ marginTop: 12, marginBottom: 8 }}>
          <Checkbox
            onChange={e =>
              form.setFieldValue(
                "fractionalPaymentChannel",
                e.target.checked ? FRACTIONAL_PAYMENT_CHANNEL_PSID : FRACTIONAL_PAYMENT_CHANNEL_STANDARD
              )
            }
          >
            {t("Deposit by PSID")}
          </Checkbox>
        </Form.Item>
      )}
    </Flex>
  )

  return (
    <Card
      Shadow={false}
      className={styles.blocksSummaryCard}
      variant="gray"
      style={{ marginTop: 12, borderRadius: 8 }}
      title={cardLabel}
      headStyle={{
        background: theme["gray100"],
      }}
      bodyStyle={{ padding: "12px 16px" }}
      styles={{ "--card-padding-block": "0px" }}
    >
      {rows.map(item => (
        <Flex key={item.label} justify="space-between" className={"mbe-4"}>
          <Text type="secondary">{item.label}</Text>
          {item.value}
        </Flex>
      ))}
      <Divider style={{ margin: "8px 0" }} />
      <Flex justify="space-between" className={"mbe-4"}>
        <Text type="secondary">{t("Grand total")}</Text>
        <span className={styles.grandTotalValue}>{formatFractionalSaleAmount(grandTotal)}</span>
      </Flex>
    </Card>
  )
}
